import { ArticleCardData } from "@baseComponents/ArticleCard";

export const articleCardJustLocalized: { [locale: string]: ArticleCardData } = {
  pl: {
    area: "agile",
    image: { src: "/just/cover.png", alt: "Just" },
    title: "Just – aplikacja do dzielenia wydatków",
    description:
      "Aplikacja Just to wygodne narzędzie do rozliczania wspólnych wydatków ze znajomymi. Dzięki sprytnemu algorytmowi zapewnia sprawiedliwy podział kosztów i proponuje optymalne rozliczenia. Dostępna na Androida i iOS.",
    date: new Date("2022-12-06"),
    timeToRead: 1,
    href: "/just",
  },
  en: {
    area: "agile",
    image: { src: "/just/cover.png", alt: "Just" },
    title: "Just – smart expense sharing app",
    description:
      "Just is a simple and intuitive app for splitting expenses with friends. A smart algorithm ensures fair cost sharing and suggests the most efficient way to settle balances. Available for both Android and iOS platforms.",
    date: new Date("2022-12-06"),
    timeToRead: 1,
    href: "/just",
  },
};
